<ng-container *hasPermission="PermissionForStudents.INTERVIEW_VIEW">
  <div class="container-fluid interview-page-container">
    <div class="interview-prep-card">
      <div class="prep-left">
        <div class="prep-icon">
          <img src="/assets/images/brain.png" alt="brain Icon" />
        </div>

        <div class="prep-content">
          <h2>Interview Preparation</h2>
          <p>Master your interviews with AI-powered practice sessions</p>

          <div class="prep-features">
            <span><i class="bi bi-stars"></i> Personalized Questions</span>
            <span><i class="bi bi-bar-chart-line"></i> Real-time Feedback</span>
            <span><i class="bi bi-graph-up-arrow"></i> Track Progress</span>
          </div>
        </div>
      </div>

      <div class="prep-right">
        <ng-container *hasPermission="PermissionForStudents.INTERVIEW_TAKE">
          <button class="start-btn" (click)="startInterview()">
            <i class="bi bi-plus-lg"></i> Start Interview
          </button>
          <p class="prep-timer">Ready in under 2 minutes</p>
        </ng-container>
      </div>
    </div>

    <!-- TABS -->
    <div class="tabs-container mt-4 mb-4">
      <div class="tabs-wrapper">
        <button
          class="tab-btn"
          [class.active]="activeTab === 'mock'"
          (click)="setTab('mock')"
        >
          <i class="bi bi-camera-video"></i> All Mock Interview
        </button>
        <button
          class="tab-btn"
          [class.active]="activeTab === 'history'"
          (click)="setTab('history')"
        >
          <i class="bi bi-clock-history"></i> History
        </button>
      </div>
    </div>

    <!-- MOCK INTERVIEWS TAB -->
    <div *ngIf="activeTab === 'mock'" class="mock-interviews-container">
      <div class="interview-header">
        <div class="header-left">
          <div class="header-icon">
            <i class="bi bi-camera-video"></i>
          </div>
          <div class="header-text">
            <h2>Available Mock Interviews</h2>
            <p>Select a practice interview round and test your skills</p>
          </div>
        </div>

        <div class="header-right">
          <div class="search-filter">
            <div class="search-box">
              <i class="bi bi-search"></i>
              <input
                type="text"
                placeholder="Search by role name..."
                [(ngModel)]="mockSearchTerm"
                (input)="onMockSearchChange()"
              />
            </div>

            <div class="filter-dropdown">
              <i class="bi bi-funnel"></i>
              <select
                [(ngModel)]="mockSelectedCategory"
                (change)="onMockCategoryChange()"
              >
                <option value="All">All Categories</option>
                <option value="Technical">Technical</option>
                <option value="Management">Management</option>
                <option value="General">General</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <!-- CARDS GRID -->
      <div *ngIf="!mockLoading; else mockLoader">
        <div
          class="interview-card-grid"
          *ngIf="mockInterviews && mockInterviews.length > 0; else noMockData"
        >
          <div
            class="interview-card mock-interview-card"
            *ngFor="let interview of mockInterviews"
          >
            <div class="card-header">
              <div class="left-section">
                <div class="company-logo-wrap">
                  <img
                    *ngIf="interview.practice_company_logo"
                    [src]="interview.practice_company_logo"
                    (error)="interview.practice_company_logo = null"
                    [alt]="interview.practice_company_name || 'Company'"
                  />
                  <div
                    *ngIf="!interview.practice_company_logo"
                    class="company-logo-placeholder"
                  >
                       {{ interview.practice_company_name?.charAt(0)?.toUpperCase() || 'N/A' }}
                  </div>
                </div>

                <div class="title-section">
                  <h3 class="role-title" [title]="interview.job_role">
                    {{ interview.job_role }}
                  </h3>
                  <span
                    class="company-name"
                    [title]="interview.practice_company_name"
                    >{{
                      interview.practice_company_name || "Practice Interview"
                    }}</span
                  >
                </div>
              </div>

              <span
                class="category-pill"
                [class.technical]="
                  interview.interview_category?.toLowerCase() === 'technical'
                "
                [class.management]="
                  interview.interview_category?.toLowerCase() === 'management'
                "
                *ngIf="interview.interview_category"
              >
                {{ interview.interview_category }}
              </span>
            </div>

            <div class="card-body">
              <div class="meta-row">
                <div class="meta-item">
                  <div class="meta-icon video-icon">
                    <i class="bi bi-camera-video"></i>
                  </div>
                  <span class="meta-text">AI Interview</span>
                </div>

                <div class="meta-item">
                  <div class="meta-icon time-icon">
                    <i class="bi bi-clock"></i>
                  </div>
                  <span class="meta-text"
                    >{{ interview.total_duration_minutes || 0 }} Minutes</span
                  >
                </div>
              </div>

              <ng-container *ngIf="interview.latest_attempt_status == 'COMPLETED'
              || interview.latest_attempt_status == 'IN_PROGRESS'">
              <button
                class="start-mock-btn"
                (click)="startMockInterview(interview.id)"
              >
                <span>Retake Mock Interview</span>
                <i class="bi bi-arrow-repeat"></i>
              </button>
              </ng-container>

              <ng-container *ngIf="interview.latest_attempt_status == null && interview.latest_session_id == null">
              <button
                class="start-mock-btn"
                (click)="startMockInterview(interview.id)"
              >
                <span>Start Mock Interview</span>
                <i class="bi bi-arrow-right"></i>
              </button>
              </ng-container>
            </div>
          </div>
        </div>

        <ng-template #noMockData>
          <div class="no-data-container">
            <i class="bi bi-clipboard-x"></i>
            <p *ngIf="mockSearchTerm || mockSelectedCategory !== 'All'">
              No practice interviews found matching your search or filter.
            </p>
            <p *ngIf="!mockSearchTerm && mockSelectedCategory === 'All'">
              No practice interviews available at this time.
            </p>
            <button
              class="clear-filter-btn"
              *ngIf="mockSearchTerm || mockSelectedCategory !== 'All'"
              (click)="clearMockFilters()"
            >
              <i class="bi bi-x-circle"></i> Clear Filters
            </button>
          </div>
        </ng-template>

        <!-- MOCK INTERVIEWS PAGINATION -->
        <div
          class="unified-pagination mt-4"
          *ngIf="mockTotalRecords > mockPageSize"
        >
          <p-paginator
            [rows]="mockPageSize"
            [totalRecords]="mockTotalRecords"
            [first]="(mockPage - 1) * mockPageSize"
            [rowsPerPageOptions]="[6, 9, 12, 18, 24]"
            (onPageChange)="onMockPageChange($event)"
          ></p-paginator>
        </div>
      </div>

      <!-- SKELETON LOADER -->
      <ng-template #mockLoader>
        <div class="interview-card-grid skeleton-grid">
          <div
            class="interview-card skeleton-card"
            *ngFor="let s of [1, 2, 3, 4, 5, 6]"
          >
            <div class="card-header">
              <div class="left-section">
                <div class="avatar skeleton-circle"></div>
                <div class="title-section">
                  <div class="skeleton-line w-70"></div>
                  <div class="skeleton-line w-40"></div>
                </div>
              </div>
            </div>

            <div class="card-body">
              <div class="d-flex gap-3 mb-3">
                <div class="skeleton-line w-30 mb-0"></div>
                <div class="skeleton-line w-30 mb-0"></div>
              </div>
              <div class="skeleton-btn"></div>
            </div>
          </div>
        </div>
      </ng-template>
    </div>

    <!-- INTERVIEW HISTORY -->
    <div *ngIf="activeTab === 'history'" class="interview-history-container">
      <div class="interview-header">
        <div class="header-left">
          <div class="header-icon"><i class="bi bi-bar-chart-line"></i></div>
          <div class="header-text">
            <h2>{{ getHeaderTitle() }}</h2>
            <p>{{ getHeaderSubtitle() }}</p>
          </div>
        </div>

        <div class="header-right">
          <div class="search-filter">
            <div class="search-box">
              <i class="bi bi-search"></i>
              <input
                type="text"
                placeholder="Search interviews..."
                [(ngModel)]="searchTerm"
                (input)="onSearchChange()"
              />
            </div>

            <!-- Type Filter Dropdown on Right Side -->
            <div class="history-filter-wrapper position-relative">
              <button
                class="history-filter-trigger-btn"
                type="button"
                (click)="toggleHistoryFilterDropdown($event)"
                title="Filter history by category"
              >
                <i class="bi bi-funnel-fill filter-icon"></i>
                <span class="filter-label">{{ getHistoryFilterLabel() }}</span>
                <i
                  class="bi bi-chevron-down chevron-icon"
                  [class.rotated]="isHistoryFilterOpen"
                ></i>
              </button>

              <!-- Floating Dropdown Menu -->
              <div
                class="history-filter-menu"
                *ngIf="isHistoryFilterOpen"
                (click)="$event.stopPropagation()"
              >
                <div class="filter-menu-header">Filter by Type</div>
                <button
                  type="button"
                  class="filter-menu-item"
                  [class.active]="historyFilter === 'all'"
                  (click)="onHistoryFilterChange('all')"
                >
                  <div class="item-left">
                    <i class="bi bi-collection-fill item-icon all-icon"></i>
                    <span>All</span>
                  </div>
                  <i
                    class="bi bi-check2 check-icon"
                    *ngIf="historyFilter === 'all'"
                  ></i>
                </button>
                <button
                  type="button"
                  class="filter-menu-item"
                  [class.active]="historyFilter === 'company'"
                  (click)="onHistoryFilterChange('company')"
                >
                  <div class="item-left">
                    <i class="bi bi-building item-icon company-icon"></i>
                    <span>Company Specific</span>
                  </div>
                  <i
                    class="bi bi-check2 check-icon"
                    *ngIf="historyFilter === 'company'"
                  ></i>
                </button>
                <button
                  type="button"
                  class="filter-menu-item"
                  [class.active]="historyFilter === 'ai'"
                  (click)="onHistoryFilterChange('ai')"
                >
                  <div class="item-left">
                    <i class="bi bi-robot item-icon ai-icon"></i>
                    <span>AI Mock Interview</span>
                  </div>
                  <i
                    class="bi bi-check2 check-icon"
                    *ngIf="historyFilter === 'ai'"
                  ></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- CARDS IN ONE UNIFIED GRID -->
      <div *ngIf="!isHistoryLoading; else loader">
        <div class="interview-card-grid" *ngIf="!isHistoryEmpty; else noData">
          <div
            class="interview-card"
            *ngFor="let item of combinedHistory"
          >
            <div class="card-header">
              <div class="left-section">
                <div class="avatar">
                  <i class="bi bi-person"></i>
                </div>

                <div class="title-section">
                  <h3 class="role-title">{{ item.role }}</h3>
                  <div class="tags">
                    <span class="round-badge">{{ item.roundBadge }}</span>
                  </div>
                </div>
              </div>

               <ng-container                 
             *hasPermission="PermissionForStudents.INTERVIEW_DELETE">
              <button
                class="delete-btn"
                title="Delete Interview"
                (click)="deleteInterview(item.sessionId)"
                *ngIf="item.canDelete"
              >
                <i class="bi bi-trash3"></i>
              </button>
                </ng-container>
            </div>

            <div class="card-body">
              <div class="meta-row">
                <div class="meta-item">
                  <div class="meta-icon name-icon">
                    <i class="bi bi-person"></i>
                  </div>
                  <span class="meta-text">{{ item.candidateName }}</span>
                </div>

                <div class="meta-item">
                  <div class="meta-icon date-icon">
                    <i class="bi bi-calendar-event"></i>
                  </div>
                  <span class="meta-text">{{ item.displayDate }}</span>
                </div>

                <div class="meta-item">
                  <div class="meta-icon time-icon">
                    <i class="bi bi-clock"></i>
                  </div>
                  <span class="meta-text">{{ item.displayDuration }}</span>
                </div>
              </div>

              <hr class="card-divider" />

              <div class="performance">
                <div class="performance-header">
                  <span class="perf-title">Performance</span>
                  <span
                    class="status"
                    [ngClass]="item.statusClass"
                  >
                    {{ item.status }}
                  </span>
                </div>

                <div class="progress-container">
                  <div class="progress-bar">
                    <div
                      class="progress-fill"
                      [ngStyle]="{
                        width: item.score + '%',
                        background: item.color
                      }"
                    ></div>
                  </div>

                  <div
                    class="score-badge"
                    [ngStyle]="{ background: item.color }"
                  >
                    {{ getScore(item.score) }}
                  </div>
                </div>
              </div>

              <button
                class="view-btn"
                (click)="viewReport(item)"
                *hasPermission="PermissionForStudents.INTERVIEW_VIEW_RESULTS"
              >
                View Detailed Report
              </button>
            </div>
          </div>
        </div>

        <ng-template #noData>
          <div class="no-data-container">
            <i class="bi bi-clipboard-x"></i>
            <p *ngIf="searchTerm">
              No interviews found matching "{{ searchTerm }}".
            </p>
            <p *ngIf="!searchTerm">No interviews found in your history.</p>
            <button
              class="clear-filter-btn"
              *ngIf="searchTerm"
              (click)="clearHistorySearch()"
            >
              <i class="bi bi-x-circle"></i> Clear Search
            </button>
          </div>
        </ng-template>
      </div>

      <!-- SKELETON LOADER -->
      <ng-template #loader>
        <div class="interview-card-grid skeleton-grid">
          <div
            class="interview-card skeleton-card"
            *ngFor="let s of [1, 2, 3, 4, 5, 6]"
          >
            <div class="card-header">
              <div class="left-section">
                <div class="avatar skeleton-circle"></div>
                <div class="title-section">
                  <div class="skeleton-line w-70"></div>
                  <div class="skeleton-line w-40"></div>
                </div>
              </div>
            </div>

            <div class="card-body">
              <div class="d-flex gap-3 mb-2">
                <div class="skeleton-line w-30 mb-0"></div>
                <div class="skeleton-line w-30 mb-0"></div>
                <div class="skeleton-line w-30 mb-0"></div>
              </div>

              <hr />

              <div class="performance">
                <div class="skeleton-line w-30"></div>
                <div class="skeleton-progress"></div>
              </div>

              <div class="skeleton-btn"></div>
            </div>
          </div>
        </div>
      </ng-template>

      <!-- SINGLE UNIFIED PAGINATION -->
      <div
        class="unified-pagination mt-4"
        *ngIf="getEffectiveTotalRecords() > 0"
      >
        <p-paginator
          [rows]="getEffectivePageSize()"
          [totalRecords]="getEffectiveTotalRecords()"
          [first]="getEffectiveFirst()"
          [rowsPerPageOptions]="[5, 10, 20, 30, 40, 50, 100]"
          (onPageChange)="onUnifiedPageChange($event)"
        ></p-paginator>
      </div>
    </div>
  </div>
</ng-container>
